import { render, staticRenderFns } from "./rateTable.vue?vue&type=template&id=52a99371&scoped=true"
import script from "./rateTable.vue?vue&type=script&lang=js"
export * from "./rateTable.vue?vue&type=script&lang=js"
import style0 from "./rateTable.vue?vue&type=style&index=0&id=52a99371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a99371",
  null
  
)

export default component.exports